import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingFormLayout',
  props: {
    title: { default: '' },
    error: { default: '' },
    currentStep: { default: 0 },
    steps: { default: 0 }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})